import { withPlugins, inview } from '@spon/plugins';
import resetFormie from '@/utils/formie';
import { eventBus } from '@spon/plugins';

function Footer({ node, plugins: { inview } }) {
	// If no Footer, such as 404
	if (!node) return () => {};
	// Moved footer video to it's own thing
	const player =
		document.querySelectorAll('footer video, footer media-player') ?? null;

	if (!player) return () => {};

	inview.settings = {
		rootMargin: '25% 0px', // Load elements when they are one viewport height away
		threshold: 0,
	};

	inview.observe(node, {
		enter: () => {
			player.forEach(player => {
				if (player.checkVisibility()) {
					player.play();
				}
			});
		},
		exit: () => {
			player.forEach(player => player.pause());
		},
	});

	eventBus.emit('ExperienceController:update', [
		...node.querySelectorAll('[data-scene]'),
	]);

	return () => {
		if (inview && typeof inview.disconnect === 'function') {
			inview.disconnect();
		}

		resetFormie();
	};
}

export default withPlugins(inview)(Footer);
